import UseProductIdentifiers from './useProductIdentifiers';

export default {
  UseProductIdentifiers,
};
